<template>
  <div class="main_home">
    <div class="main_header">
        <h1 style="font-size:30px;text-align: center;width: 100%;margin: 0 auto;padding: 0;background: #0072ff;line-height: 70px;color: white;">
            {{ company.name }}
        </h1>
    </div>
    <div class="main_title" style="margin-top:40px;">
        <ul>
            <li>
                <el-image fit="cover"  class="main_title_img" :src="require('@/assets/password.png')">
                </el-image>
            </li>
            <li>
                <span>
                    修改密码
                </span>
            </li>
        </ul>
    </div>
    <div class="main_content">
        <ul style="overflow:hidden;">
            <li style="width:100%;height:70px;">
                <a-input-password v-model="password" @pressEnter="bind" ref="userPasswordInput" size="large" placeholder="请输入新密码" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input-password >
            </li>
            <li style="width:100%;height:70px;">
                <a-input-password  v-model="repassword" @pressEnter="bind" ref="userRepasswordInput" size="large" placeholder="请重新输入新密码" style="width:100%;height:50px;margin-top:20px;font-size:20px;">
                    <a-icon type="user" />
                </a-input-password >
            </li>
            <li style="width:100%;height:70px;">
                <a-button :loading="commit_loading" @click="resetPassword" style="border-radius:5px;background:#1890ff;display:block;width:100%;height:50px;line-height:50px;margin-top:20px;color:white;font-size:20px;text-align:center;">
                    完成修改
                </a-button>
            </li>
        </ul>
    </div>
  </div>
</template>

<script>

import request from '../../api/request'
import company_model from '../../model/company'
import watermark from 'watermark-dom'

export default {
    name: 'ResetPassword',
    head: {
        title: "重置密码",
        meta:[
            { name: 'description', content: '重置密码'}
        ]
    },
    data: function() {
        return {
            commit_loading: false,
            validation_token: "",
            password: "",
            repassword: "",
            company: company_model,
        }
    },
    methods: {
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        load() {
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_company()
            this.validation_token = this.$route.query.validation_token
        },
        resetPassword() {
            this.commit_loading = true
            let resp = request.site_user.reset_password(this.validation_token, this.password, this.repassword)
            resp.then((response) => {
                this.commit_loading = false
                if (response.status == 200 && response.data.code == 0) {
                    var success_message = response.data.message
                    if (!success_message) {
                        success_message = "修改密码成功"
                    }
                    this.$message.success(success_message)
                    this.$router.push('/user/login')
                }
                else {
                    var failed_message = response.data.message
                    if (!failed_message) {
                        failed_message = "修改密码失败"
                    }
                    this.$message.error(failed_message)
                }
            })
            .catch((error) => {
                this.commit_loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })

        },
    },
    created() {
        this.load()
    },
    components: {

    }
}
</script>

<style>

html {
  margin: 0;
  padding: 0;
}

body {
  margin: 0; 
  padding: 0;
}

ul {
  list-style: none;
}

.main_home {
  height: 100%;
  margin: 0;
  padding: 0;
}

.main_header {
    text-align: center;
    width: 100%;
    margin: 0 auto;
    padding: 0;
}

.main_title {
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 20px;
    height: 50px;
}

.main_title ul {
    margin: 0 auto;
    padding: 0;
    height: 100%;
}


.main_title ul li {
    height: 100%;
    margin: 0 auto;
    padding: 0;
    float: left;
}

.main_title ul li:last-child {
    margin-left: 20px;
}

.main_title_img {
    width: 50px;
    height: 50px;
}

.main_title ul > li > span {
    display: block;
    margin: 0 auto;
    padding: 0;
    line-height: 50px;
    font-size: 20px;
}

.main_content > ul {
    margin: 0;
    padding: 0;
    height: 310px;
}



</style>
